import { createContext } from '@lit/context';
import { UserProfile } from '../types';

export interface IContext {
  profile?: UserProfile;
}

export const context = createContext<IContext>('menu');
